import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export type CompanyStatus = 'PENDING_KYB' | 'ACTIVE' | 'SUSPENDED';

/** GET /companies/me — tenant firma kaydı (durum + sözleşme no'ları dahil). */
export interface CompanyMe {
  id: string;
  legalName: string;
  taxNumber: string;
  taxOffice: string | null;
  address: string | null;
  phone: string | null;
  status: CompanyStatus;
  custelMsaNo: string | null;
  custelEkNo: string | null;
  custelNdaNo: string | null;
  custelSlaNo: string | null;
  kybSubmittedAt: string | null;
  kybApprovedAt: string | null;
  dataResidency?: 'EU_ONLY' | 'EU_PRIMARY_US_FALLBACK';
  dataResidencyAcceptedAt?: string | null;
}

/**
 * useCompany — mevcut firma kaydı (CompanyPage ile aynı `['company']` cache key'i paylaşır).
 * PENDING_KYB feature-lock + firma kaydı sayfası bunu kullanır.
 */
export function useCompany() {
  return useQuery({
    queryKey: ['company'],
    queryFn: () => api.get<CompanyMe>('/companies/me'),
    staleTime: 30_000,
  });
}
